import i18n from '@/lib/i18n';
import { DeviceService } from '@/service/DeviceService.ts';
import { useDeviceStore } from '@/store/DeviceStore';
import { CameraListener } from 'mind-sdk-web';
import { Camera as MindCamera } from 'mind-sdk-web/lib/Camera';

export class CameraEventListener implements CameraListener {
  constructor(readonly deviceService: DeviceService) {}

  onCameraReleasedForcibly(camera: MindCamera) {
    if (camera.getId() !== 'default') {
      console.warn(i18n.t('events.camera.noStream'));
    }

    // Mark camera as unset. Unlike `disable`, this explicitly means the user didn’t turn it off manually.
    useDeviceStore.getState().setCamera(null);

    // Try to reselect a default camera immediately.
    // This helps:
    // - recover the camera ASAP if it's still usable
    // - surface permission or device errors to the user
    this.deviceService.useDefaultCamera().catch((error) => {
      console.error(i18n.t('events.camera.errorSelectingDefault'), error);
    });
  }
}
